import $ from 'jquery';
import {
  Swiper, EffectFade, Navigation, Lazy, Pagination,
} from 'swiper';
import { breakpoints } from '../../config/breakpoints';

const swipers = [];
const btns = '.room-type__tab';
const accommodationContainer = '.room-type';
const swiperContainerClass = '.js-room-type-slider';
const accommodationContent = '.room-type__content';
const accomodationSelect = '.room-type__select';
let width = window.innerWidth;

$(accommodationContainer).find(accommodationContent).not(':first-of-type').hide();

$(btns).on('click', function () {
  const currentTab = $(this).data('tab');
  const parentEl = $(this).closest(accommodationContainer);
  parentEl.find(btns).removeClass('active');
  $(this).addClass('active');
  parentEl.find(accommodationContent).hide().removeClass('showed');
  parentEl.find(`.room-type__content[data-content="${currentTab}"]`).show().addClass('showed');
});

$(accomodationSelect).on('change', function () {
  const parentEl = $(this).closest(accommodationContainer);
  const selected = $(this).find(':selected').data('tab');
  parentEl.find(accommodationContent).hide().removeClass('showed');
  parentEl.find(`.room-type__content[data-content="${selected}"]`).show().addClass('showed');
});

function refreshTabindex() {
  const $container = $('.swiper-slide a, .swiper-slide .c-expander__button-label');
  $container.attr('tabindex', -1);
  setTimeout(() => {
    const $containerActive = $('.swiper-slide-active a, .swiper-slide-active .c-expander__button-label');
    $containerActive.attr('tabindex', 0);
  }, 0);
}

function initSwiperContentSlider($slider) {
  const currentSlide = $slider.attr('current-slide') ? $slider.attr('current-slide') : 0;
  const swiper = new Swiper($slider[0], {
    effect: 'slide',
    lazy: {
      loadPrevNext: true,
      preloaderClass: 'swiper__preloader',
    },
    spaceBetween: 0,
    loop: true,
    autoHeight: true,
    initialSlide: currentSlide,
    navigation: {
      nextEl: $slider.find('.room-type__arrow--next')[0],
      prevEl: $slider.find('.room-type__arrow--prev')[0],
    },
    pagination: {
      clickable: true,
      el: '.room-type__pagination',
      renderBullet: (index, className) => `<button class="${className}" aria-label="Choose slide to display"></button>`,
    },
    modules: [EffectFade, Navigation, Lazy, Pagination],
    on: {
      init() {
        refreshTabindex();
      },
      slideChange() {
        refreshTabindex();
      },
    },
  });

  swipers.push(swiper);
}

function refreshPagination($slider) {
  if ($(window).width() < breakpoints.lg) {
    const pagination = $slider.find('.content-slider__nav-container .content-slider__pagination');
    const nav = $slider.find('.content-slider__nav');

    pagination.removeClass('content-slider__pagination--gray');
    nav.removeClass('position-absolute');
    pagination.addClass('content-slider__pagination--white position-absolute w-100 text-center');
    $slider.prepend(pagination);
  } else {
    const paginationContainer = $slider.find('.content-slider__nav-container');
    const pagination = $slider.find('.content-slider__pagination');
    pagination.removeClass('content-slider__pagination--white position-absolute w-100 text-center');
    paginationContainer.prepend(pagination);
  }
}

function init() {
  const $boxes = $(swiperContainerClass);
  $boxes.each(function () {
    const $slider = $(this);
    refreshPagination($slider);
    initSwiperContentSlider($slider);
  });
}

window.addEventListener('resize', () => {
  if (width !== window.innerWidth) {
    width = window.innerWidth;
    swipers.forEach((swiper) => {
      swiper.destroy();
      // eslint-disable-next-line no-param-reassign
      swiper = null;
    });

    init();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  init();
});
